import React from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import {PinModal} from '/component/partial/PinModal';
import {Login} from '/constant/TestIDs';
import {LOGIN_TYPE} from '/enum/biometrics.enum';
import {checkPin, handlePinLogin} from '/util/pinCore.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './BiometricsAndPinSection.style';

interface BiometricsAndPinSectionProps {
  setValue: (value: any) => void;
  handleOnSubmit: (loginType: typeof LOGIN_TYPE) => void;
  showPopup: (component: React.ComponentType, props: any, options: any) => void;
  hidePopup: () => void;
  getUserPinValue: () => Promise<string>;
  pinOptIn: boolean;
}

export const BiometricsAndPinSection: React.FC<
  BiometricsAndPinSectionProps
> = ({
  setValue = noop,
  handleOnSubmit = noop,
  showPopup = noop,
  hidePopup = noop,
  getUserPinValue = noop,
  pinOptIn = false,
}) => {
  const handlePinPress = async (e: any) => {
    await checkPin({
      pin: e,
      getUserPinValue,
      hidePopup,
      handlePinLogin,
      setValue,
      handleOnSubmit: () => handleOnSubmit(LOGIN_TYPE.pin),
    })();
  };

  return (
    <View style={styles.biometricAndPinContainer}>
      {pinOptIn && (
        <TouchableOpacity
          style={styles.pinContainer}
          onPress={() => {
            showPopup(
              PinModal,
              {
                showCreatePinModal: false,
                skipButton: hidePopup,
                onSubmit: handlePinPress,
              },
              {avoidable: false, showFullModal: true},
            );
          }}
          {...testProperties(null, true)}>
          <Icon name="PIN" style={styles.itemIcon} />
          <Text
            style={styles.biometricLabel}
            {...testProperties(Login.loginPinButton)}>
            PIN
          </Text>
        </TouchableOpacity>
      )}
    </View>
  );
};
